// AUTO-GENERATED by scripts/generate-version.js — do not edit by hand.
// Version is read from package.json; date is stamped at build time.
export const APP_VERSION = '5.0.0';
export const BUILD_DATE  = '2026-06-24';

export const VERSION_LABEL = `v${APP_VERSION} · ${new Date(BUILD_DATE).toLocaleDateString('en-MY', {
  day: '2-digit', month: 'short', year: 'numeric',
})}`;
